import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-success',
  imports: [TranslatePipe],
  templateUrl: './reset-success.component.html',
  styleUrl: './reset-success.component.scss',
})
export class ResetSuccessComponent {
  public goToSignIn = output();

  public redirectToSignIn() {
    this.goToSignIn.emit();
  }
}
